import React from 'react';
function LayersBackground({ size, stroke = 'currentColor', ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={stroke}
      {...otherProps}
    >
      <path
        id="Stroke"
        d="M10.5 21H14C14.5523 21 15 20.5523 15 20V18M10.5 21H7M10.5 21L13.5 18M7 21H4C3.44772 21 3 20.5523 3 20V17M7 21L10 18M3 17V13M3 17L6 14M3 13V10C3 9.44772 3.44772 9 4 9H6M3 13L6 10M3.5 20.5L6.5 17.5M18 15V17C18 17.5523 17.5523 18 17 18H7C6.44772 18 6 17.5523 6 17V7C6 6.44772 6.44772 6 7 6H9M10 15H20C20.5523 15 21 14.5523 21 14V4C21 3.44772 20.5523 3 20 3H10C9.44772 3 9 3.44772 9 4V14C9 14.5523 9.44772 15 10 15Z"
      />
    </svg>
  );
}

export default LayersBackground;
